import React, {Suspense} from 'react'

import teamInvitationQuery, {} from '~/__generated__/TeamInvitationQuery.graphql'
import useNoIndex from '~/hooks/useNoIndex'
import useQueryLoaderNow from '../hooks/useQueryLoaderNow'
import TeamInvitation from './TeamInvitation'



const TeamInvitationRoot = (props) => {
  useNoIndex()
  const {match} = props
  const {params} = match
  const {token} = params
  const queryRef = useQueryLoaderNow(teamInvitationQuery, {token})
  return React.createElement(Suspense, { fallback: '',}, queryRef && React.createElement(TeamInvitation, { queryRef: queryRef,} ))
}

export default TeamInvitationRoot
